import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";

// Layout compartilhado por todas as rotas: Header e Footer fixos,
// e o conteúdo da página atual é renderizado no lugar de <Outlet />.
export default function Layout() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}
